module.exports = __webpack_public_path__ + "static/avatar-36c04164009bdadc2d891937bbedebcb.jpg";